import { render, staticRenderFns } from "./ClientPaymentsBookingFee.vue?vue&type=template&id=45082a7a&scoped=true&"
import script from "./ClientPaymentsBookingFee.vue?vue&type=script&lang=js&"
export * from "./ClientPaymentsBookingFee.vue?vue&type=script&lang=js&"
import style0 from "./ClientPaymentsBookingFee.vue?vue&type=style&index=0&id=45082a7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45082a7a",
  null
  
)

export default component.exports